<template>
  <div class="dialog">
    <span class="cls" @click="oth_showProfileDialog(false)"></span>
    <div class="paper">

      <template v-if="member">

        <!-- 수정 모드 -->
        <Transition name="slide">
          <div class="edit-mode" v-if="isEditing">
            <div class="edit-header">
              <button class="edit-back-btn" @click="isEditing = false">
                <i class="ph-bold ph-arrow-left"></i>
              </button>
              <h3>프로필 수정</h3>
              <button class="edit-save-btn" @click="saveUserInfo" :disabled="isSaving">
                <template v-if="isSaving">
                  <i class="ph ph-spinner spin-icon"></i>
                </template>
                <template v-else>저장</template>
              </button>
            </div>

            <div class="edit-body">
              <!-- 프로필 이미지 변경 -->
              <div class="avatar-upload">
                <label for="profileImgInput">
                  <div class="avatar-wrapper">
                    <img :src="editForm.image" />
                    <div class="avatar-overlay">
                      <i class="ph-bold ph-camera"></i>
                      <span>변경</span>
                    </div>
                  </div>
                </label>
                <input type="file" id="profileImgInput" @change="profileImgOnFileChange" hidden accept="image/*" />
              </div>

              <!-- 폼 필드 -->
              <div class="form-fields">
                <div class="field">
                  <label>이름</label>
                  <input type="text" :value="editForm.name" readonly class="readonly" />
                </div>
                <div class="field">
                  <label>닉네임</label>
                  <input type="text" v-model="editForm.nickname" placeholder="닉네임을 입력하세요" />
                </div>
                <div class="field">
                  <label>소개</label>
                  <textarea v-model="editForm.introduce" placeholder="나를 소개해주세요" rows="3"></textarea>
                </div>
                <div class="field">
                  <label>연락처</label>
                  <input type="tel" v-model="editForm.phone" placeholder="연락처를 입력하세요" />
                </div>
              </div>
            </div>
          </div>
        </Transition>

        <!-- 보기 모드 -->
        <template v-if="!isEditing">

          <!-- 상단 프로필 박스 -->
          <div class="box profile-box">
          
            <div class="profile-header">
              <img :src="member.image" class="profile-image"/>
              <div class="profile-content">
                <span class="job-title">Financial Planner</span>
                <div class="name-section">
                  <h2>{{ member.name }}</h2>
                  <span class="role">설계사</span>
                  <span class="badge">베이직</span>
                </div>
                <span class="subtitle">보험전문 상담사</span>
                <span class="phone">{{ member.phone }}</span>
              </div>
            </div>

            <div class="action-buttons">
              <button class="btn-primary" @click="goToCard">전자명함</button>
              <button class="btn-secondary">
                <i class="ph-fill ph-coin"></i> {{ member.point || 0 }}p
              </button>
              <button class="btn-icon" @click="openEditMode">
                <i class="ph-bold ph-pencil-simple"></i>
              </button>
            </div>

            <div class="info-grid">
              <div class="info-item">
                <span class="label">지사</span>
                <span class="value"> <i class="ph-fill ph-tree-structure" style="color: #FFA500;"></i> VFT지사</span>
              </div>
              <div class="info-item">
                <span class="label">지점</span>
                <span class="value">논산지점</span>
              </div>
              <div class="info-item">
                <span class="label">팀</span>
                <span class="value">영업팀</span>
              </div>
            </div>

          </div>

          <!-- 활동 섹션 -->
          <div class="section">
            <h3 class="section-title">활동</h3>
            <div class="stats-grid">
              <div class="stat-card">
                <i class="ph-fill ph-folder" style="color: #FFA500;"></i>
                <span class="stat-label">공유율</span>
                <span class="stat-value">23</span>
              </div>
              <div class="stat-card">
                <i class="ph-fill ph-file-text" style="color: #FFA500;"></i>
                <span class="stat-label">게시글</span>
                <span class="stat-value">108</span>
              </div>
              <div class="stat-card">
                <i class="ph-fill ph-heart" style="color: #FFA500;"></i>
                <span class="stat-label">좋아요 받은질소</span>
                <span class="stat-value">245</span>
              </div>
            </div>
          </div>

          <!-- 뱃지 섹션 -->
          <div class="section">
            <h3 class="section-title">뱃지</h3>
            <div class="bedge-list">
              <span 
                v-for="(badge, idx) in bedgeList" 
                :key="idx"
                :style="{
                  background: badge.bg_color,
                  opacity: isBadgeAcquired(badge) ? 1 : 0.4
                }"
                :title="badge.condition"
              >
                <img :src="`/imgs/bedge/${badge.img}`" />
                {{ badge.name }}
              </span>
            </div>
          </div>

          <!-- 역할 섹션 -->
          <div class="section">
            <h3 class="section-title">역할</h3>
            <div class="tags">
              <span class="tag">#건강보험</span>
              <span class="tag">#교육담당</span>
              <span class="tag">#우수인증설계사</span>
            </div>
          </div>

        </template>

      </template>

    </div>
  </div>
</template>

<script>
import { inject, ref, reactive } from "vue";
import { useBackButton } from '@/utils/useBackBtn';

export default {
  name: "ProfileDialog",
  props: {
    mb_id: { type: String },
    oth_showProfileDialog: { type: Function, default: () => {} }
  },
  setup(props) {
    const getUserProfileInfo = inject('getUserProfileInfo');
    const getMbid = inject('getMbid');
    const sql_query = inject('sql_query');
    const member = ref({});
    const mb_id = ref(null);
    const badgeCounts = ref({});
    const isEditing = ref(false);
    const isSaving = ref(false);

    const editForm = reactive({
      image: '',
      name: '',
      nickname: '',
      introduce: '',
      phone: ''
    });

    const bedgeList = [
      {
        name:"열혈상담가", 
        bg_color:"#FFF1DB", 
        img:"diary.png", 
        condition:"QNA 답변, 상담 총합 5개 넘김",
        check: (c) => (c.qna_answer_cnt || 0) + (c.qna_question_cnt || 0) >= 5
      },
      {
        name:"청구해결사", 
        bg_color:"#DBF2FF", 
        img:"money.png", 
        condition:"실제 청구사례 1회 이상 기록",
        check: (c) => (c.insu_claims_cnt || 0) >= 1
      },
      {
        name:"보장분석왕", 
        bg_color:"#FFE1DB", 
        img:"chart.png", 
        condition:"보장 스케치를 5개 이상 만듦",
        check: (c) => (c.solution_cnt || 0) >= 5
      },
      {
        name:"지식나눔러", 
        bg_color:"#FFF1DB", 
        img:"star.png", 
        condition:"공유 플랜/솔루션을 5개 이상 공유",
        check: (c) => (c.solution_public_cnt || 0) >= 5
      },
      {
        name:"오늘도출근", 
        bg_color:"#FFF1DB", 
        img:"clock.png", 
        condition:"휴일, 공휴일 제외 결근이 없는 사람",
        check: (c) => (c.attendance_cnt || 0) >= 20
      },
      {
        name:"목표달성가", 
        bg_color:"#FFE1DB", 
        img:"target.png", 
        condition:"자신이 세운 목표 3, 공통과제 3 모두 클리어",
        check: (c) => (c.personal_goal_cnt || 0) >= 3 && (c.common_goal_cnt || 0) >= 3
      },
      {
        name:"보험덕후", 
        bg_color:"#DBF2FF", 
        img:"person.png", 
        condition:"커뮤니티, QNA 등에 댓글을 5개 이상 달기",
        check: (c) => (c.qna_answer_cnt || 0) + (c.qna_question_cnt || 0) + (c.sns_post_cnt || 0) >= 5
      },
    ];
    
    useBackButton(() => {
      if (isEditing.value) {
        isEditing.value = false;
      } else {
        props.oth_showProfileDialog(false);
      }
    });

    async function fetchMember() {
      let res = await getUserProfileInfo(props.mb_id);
      member.value = res;
      mb_id.value = res.mb_id;
      
      // 뱃지 카운트 조회
      await fetchBadgeCounts(res.mb_id);
    }
    
    async function fetchBadgeCounts(id) {
      let res = await sql_query(`
        SELECT 
          (SELECT COUNT(*) FROM qna_answer WHERE mb_id = '${id}') as qna_answer_cnt,
          (SELECT COUNT(*) FROM qna_question WHERE mb_id = '${id}') as qna_question_cnt,
          (SELECT COUNT(*) FROM insu_claims WHERE mb_id = '${id}') as insu_claims_cnt,
          (SELECT COUNT(*) FROM IS_solution WHERE mb_id = '${id}') as solution_cnt,
          (SELECT COUNT(*) FROM IS_solution WHERE mb_id = '${id}' AND public = 1) as solution_public_cnt,
          (SELECT COUNT(*) FROM attendance WHERE mb_id = '${id}' AND check_in IS NOT NULL AND YEAR(work_date) = YEAR(CURDATE())) as attendance_cnt,
          (SELECT COUNT(*) FROM goals WHERE mb_id = '${id}' AND status = 'complete' AND goal_type = 'personal') as personal_goal_cnt,
          (SELECT COUNT(*) FROM goals WHERE mb_id = '${id}' AND status = 'complete' AND goal_type = 'common') as common_goal_cnt,
          (SELECT COUNT(*) FROM sns_post WHERE mb_id = '${id}') as sns_post_cnt
      `);
      badgeCounts.value = res[0] || {};
    }
    
    fetchMember();
    
    function goToCard() {
      location.href = `/event/card/${mb_id.value}`;
    }
    
    function isBadgeAcquired(badge) {
      return badge.check(badgeCounts.value);
    }

    // ── 수정 모드 ──
    function openEditMode() {
      const m = member.value;
      editForm.image = m.image || '';
      editForm.name = m.name || '';
      editForm.nickname = m.nickname || '';
      editForm.introduce = m.introduce || '';
      editForm.phone = m.phone || '';
      isEditing.value = true;
    }

    async function profileImgOnFileChange(e) {
      const file = e.target.files?.[0];
      if (!file) return;

      editForm.image = URL.createObjectURL(file);

      const formData = new FormData();
      formData.append('idx', getMbid() || '');
      formData.append('table', 'member');
      formData.append('usage', 'profile_img');
      formData.append('user', getMbid());
      formData.append('file', file);

      try {
        const response = await fetch('/api/upload/image', {
          method: 'POST',
          body: formData,
          mode: 'cors',
          credentials: 'include'
        });
        const data = await response.json();
        if (data.url) {
          editForm.image = data.url;
          await sql_query(`UPDATE member SET image = '${data.url}' WHERE mb_id = '${getMbid()}'`);
        } else {
          alert("이미지 업로드 실패");
        }
      } catch (err) {
        console.error('업로드 중 오류:', err);
        alert("업로드 중 오류 발생");
      }
    }

    async function saveUserInfo() {
      isSaving.value = true;
      try {
        await sql_query(`
          UPDATE member
          SET nickname = '${editForm.nickname}',
              introduce = '${editForm.introduce}',
              phone = '${editForm.phone}',
              image = '${editForm.image}'
          WHERE mb_id = '${getMbid()}'
        `);

        // member 반영
        member.value.nickname = editForm.nickname;
        member.value.introduce = editForm.introduce;
        member.value.phone = editForm.phone;
        member.value.image = editForm.image;

        window.dispatchEvent(new CustomEvent('profile-updated', { 
          detail: {  
            mb_id: getMbid(),
            nickname: editForm.nickname,
            introduce: editForm.introduce,
            phone: editForm.phone,
            image: editForm.image
          } 
        }));

        isEditing.value = false;
      } catch (err) {
        console.error('저장 중 오류:', err);
        alert("저장 중 오류 발생");
      } finally {
        isSaving.value = false;
      }
    }
    
    return {
      member,
      goToCard,
      bedgeList,
      isBadgeAcquired,
      isEditing,
      isSaving,
      editForm,
      openEditMode,
      profileImgOnFileChange,
      saveUserInfo
    }
  }
};
</script>


<style scoped>

.dialog {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog > .paper {
  width: 90%;
  height:100%;
  max-width:600px;
  max-height:90vh;
  background: var(--color-background-light);
  border:1px solid var(--color-background-light);
  border-radius: 16px;
  padding: 12px;
  box-sizing: border-box;
  gap:12px;
  display:flex;
  flex-direction: column;
  overflow-y: auto;
  position: relative;
}

.box {
  display:flex;
  flex-direction: column;
  gap:16px;
  background: var(--color-background);
  border-radius: 16px;
  padding: 20px;
  box-sizing: border-box;
}

/* 프로필 헤더 */
.profile-header { 
  display:flex;
  flex-direction: row;
  gap:16px;
  align-items: flex-start;
}

.profile-image {
  width:120px;
  height:120px;
  object-fit:cover;
  border-radius: 50%;
  background:var(--color-background-light);
  flex-shrink: 0;
}

.profile-content {
  display:flex;
  flex-direction: column;
  gap:6px;
  flex:1;
}

.job-title {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  font-weight: var(--font-weight-normal);
}

.name-section {
  display:flex;
  flex-direction: row;
  gap:8px;
  align-items: center;
}

.name-section > h2 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  padding:0;
  margin:0;
}

.name-section > .role {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  font-weight: var(--font-weight-normal);
}

.badge {
  background: #FFE4E1;
  color: #FF69B4;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
}

.subtitle {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  font-weight: var(--font-weight-normal);
}

.phone {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

/* 액션 버튼 */
.action-buttons {
  display:flex;
  flex-direction: row;
  gap:8px;
  align-items: center;
}

.btn-primary {
  flex:1;
  height:48px;
  border-radius: 12px;
  background: #FFA500;
  border:none;
  color:#fff;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
}

.btn-secondary {
  height:48px;
  padding: 0 16px;
  border-radius: 12px;
  background: var(--color-background);
  border:2px solid var(--color-background-light);
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  display:flex;
  align-items: center;
  gap:6px;
}

.btn-secondary > i {
  color: #FFA500;
  font-size: var(--font-size-lg);
}

.btn-icon {
  width:48px;
  height:48px;
  border-radius: 12px;
  background: var(--color-background);
  border:2px solid var(--color-background-light);
  color: var(--color-text-primary);
  font-size: var(--font-size-xl);
  cursor: pointer;
  display:flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.btn-icon:active {
  background: #FFA500;
  border-color: #FFA500;
  color: #fff;
}

/* 정보 그리드 */
.info-grid {
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  gap:12px;
}

.info-item {
  display:flex;
  flex-direction: column;
  align-items: center;
  gap:8px;
  text-align: center;
}

.info-item > .label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.info-item > .value {
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  font-weight: var(--font-weight-medium);
}

/* 섹션 */
.section {
  display:flex;
  flex-direction: column;
  gap:12px;
  background: var(--color-background);
  border-radius: 16px;
  padding: 20px;
  box-sizing: border-box;
}

.section-title {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin:0;
  padding:0;
}

/* 통계 그리드 */
.stats-grid {
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  gap:12px;
}

.stat-card {
  display:flex;
  flex-direction: column;
  align-items: center;
  gap:8px;
  padding:16px;
  background: var(--color-background-light);
  border-radius: 12px;
  text-align: center;
}

.stat-card > i {
  font-size: 32px;
  margin-bottom: 4px;
}

.stat-label {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.stat-value {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

/* 태그 */
.tags {
  display:flex;
  flex-wrap: wrap;
  gap:8px;
}

.tag {
  padding: 6px 12px;
  background: var(--color-background-light);
  border-radius: 16px;
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
}

.bedge-list {
  display:grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: auto;
  gap:6px;
}

.bedge-list > span {
  display:flex;
  align-items:center;
  justify-content:start;
  gap:4px;
  padding:0px 6px;
  box-sizing:border-box;
  border-radius:6px;
  font-size:14px;
  font-weight:600;
  color:#000;
}

.bedge-list > span > img {
  width:36px;
  height:36px;
  object-fit:cover;
}

/* ── 수정 모드 ── */
.edit-mode {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--color-background);
  border-radius: 16px;
  overflow: hidden;
}

.edit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--color-background-light);
  flex-shrink: 0;
}

.edit-header h3 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.edit-back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-background-light);
  border: none;
  border-radius: 12px;
  color: var(--color-text-primary);
  font-size: var(--font-size-lg);
  cursor: pointer;
  transition: all 0.2s ease;
}

.edit-back-btn:active {
  transform: scale(0.95);
}

.edit-save-btn {
  height: 40px;
  padding: 0 20px;
  background: #FFA500;
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.edit-save-btn:active:not(:disabled) {
  transform: scale(0.97);
}

.edit-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* 아바타 업로드 */
.avatar-upload {
  display: flex;
  justify-content: center;
}

.avatar-wrapper {
  position: relative;
  width: 110px;
  height: 110px;
  cursor: pointer;
}

.avatar-wrapper img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #FFA500;
  transition: all 0.2s ease;
  box-shadow: 0 0 20px rgba(255, 165, 0, 0.15);
}

.avatar-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
  color: #fff;
}

.avatar-overlay i {
  font-size: 24px;
}

.avatar-overlay span {
  font-size: var(--font-size-xs);
}

.avatar-wrapper:active .avatar-overlay {
  opacity: 1;
}

@media (hover: hover) {
  .avatar-wrapper:hover .avatar-overlay {
    opacity: 1;
  }
}

/* 폼 필드 */
.form-fields {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.field label {
  display: block;
  margin-bottom: 8px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
}

.field input,
.field textarea {
  width: 100%;
  padding: 14px 16px;
  background: var(--color-background-light);
  border: 1px solid var(--color-background-light);
  border-radius: 12px;
  color: var(--color-text-primary);
  font-size: var(--font-size-base);
  font-family: inherit;
  transition: all 0.2s ease;
  box-sizing: border-box;
  outline: none;
}

.field input:focus,
.field textarea:focus {
  border-color: #FFA500;
  box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.12);
}

.field input.readonly {
  opacity: 0.5;
  cursor: not-allowed;
}

.field textarea {
  resize: none;
  min-height: 90px;
  line-height: 1.5;
}

/* 슬라이드 트랜지션 */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* 스피너 */
.spin-icon {
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 모바일 최적화 */
@media (max-width: 768px) {
  .profile-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .profile-content {
    align-items: center;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary,
  .btn-icon {
    width: 100%;
  }
}

</style>